import { DestinationParams, EditDestinationMeta } from '@anm/api/modules/stream';
import { FB_GROUP_HINT } from '@anm/components/stream/NewStreamModal/hooks/useSaveDestinationsMetaParams';
import { useEffect, useState } from 'react';
import { SocialDestination } from 'types/stream';

import { getFbDescription } from './helpers';

export * from './helpers';

type SaveDestinationMetaProps = {
  title: string;
  description: string;
  destinations: SocialDestination[];
  selectedDestinations: string[];
};

const useSaveDestinationsMetaParams = ({
  title,
  description,
  destinations,
  selectedDestinations
}: SaveDestinationMetaProps) => {
  const [destinationParams, setDestinationsParams] = useState({} as DestinationParams);

  useEffect(() => {
    Object.keys(destinationParams).forEach(id => {
      if (!selectedDestinations.includes(id)) {
        const newState = { ...destinationParams };
        newState[id].isHidden = true;

        setDestinationsParams(newState);
      } else if (selectedDestinations.includes(id) && destinationParams[id].isHidden) {
        const newState = { ...destinationParams };
        newState[id].isHidden = false;

        setDestinationsParams(newState);
      }
    });
  }, [selectedDestinations.length]);

  const handleSaveDestinationsParams = ({
    destinationIds,
    isSamePreview,
    isFbInstruction,
    ...params
  }: EditDestinationMeta) => {
    const destinationId = destinationIds[0];
    const destination = destinations.find(d => d.id === destinationId);

    const isGroup = destination?.kind === 'group';
    const isFbNetwork = destination?.network === 'FACEBOOK';
    const canAddInstruction = isFbInstruction && isGroup && isFbNetwork;

    setDestinationsParams(prevState => {
      const sameFields = new Set([...(prevState[destinationId]?.sameFields || [])] as string[]);

      if (isSamePreview) sameFields.add('preview');
      else sameFields.delete('preview');

      if (title === params.title) sameFields.add('title');
      else sameFields.delete('title');

      if (description === params.description) sameFields.add('description');
      else sameFields.delete('description');

      return {
        ...prevState,
        [destinationId]: {
          ...params,
          isFbInstruction,
          sameFields: [...sameFields],
          description: canAddInstruction
            ? getFbDescription(params.description)
            : params.description?.replace(FB_GROUP_HINT, '')
        }
      };
    });
  };

  return [destinationParams, handleSaveDestinationsParams, setDestinationsParams] as const;
};

export default useSaveDestinationsMetaParams;
